import clsx from 'clsx'
import styles from './controls.module.css'

interface ToggleRowProps {
  label: string
  count: number
  selected: boolean
  onClick: () => void
}

/** One switch row with its disjunctive count (boolean specs, bundles, pill "extras"). */
const ToggleRow: React.VFC<ToggleRowProps> = ({ label, count, selected, onClick }) => (
  <button type="button" className={styles.toggleRow} aria-pressed={selected} onClick={onClick}>
    <span className={styles.toggleLabel}>
      {label}
      <span className={styles.toggleCount}>{count.toLocaleString('en-US')}</span>
    </span>
    <span className={clsx(styles.switch, { [styles.switchOn]: selected })} aria-hidden="true" />
  </button>
)

export default ToggleRow
